interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <nav className="flex items-center justify-center gap-2 mt-10 flex-wrap" aria-label="分页导航">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className="px-3 h-9 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        上一页
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`w-9 h-9 rounded-md text-sm font-medium transition-colors cursor-pointer ${
            p === current
              ? "bg-primary-500 text-background-50"
              : "border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className="px-3 h-9 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        下一页
      </button>
    </nav>
  );
}